/* Header UI helpers (mega-menu, garage/vehicle-bar clicks, fitment triggers) — externalized + deferred
   2026-08-19. Were 10 self-contained inline <script> IIFEs in header.liquid, executed during parse. None
   define shared globals; all are interaction-only, so deferring runs them after parse (and after
   cpg-ymm-widget.js defines window.CPGFitment) without blocking render. Cached across all pages. */

/* ---- was header.liquid line 1138 ---- */
document.addEventListener('DOMContentLoaded', function () {

  function normalizeCpMenuTitle(value) {
    return String(value || '')
      .toLowerCase()
      .trim();
  }

  

  document.querySelectorAll('[data-cp-summit-menu]').forEach(function(menu) {

    var trigger = menu.querySelector('.cp-summit-menu__trigger');
    var drawer = menu.querySelector('.cp-summit-drawer');
    var closeButtons = menu.querySelectorAll('.cp-summit-drawer__close');
    var backButton = menu.querySelector('.cp-summit-drawer__back');
    var departments = menu.querySelectorAll('[data-cp-department]');
    var panels = menu.querySelectorAll('[data-cp-panel]');
    var subPanelTriggers = menu.querySelectorAll('[data-cp-sub-panel]');
var subPanels = menu.querySelectorAll('[data-cp-sub-panel-content]');
var backToTwoButton = menu.querySelector('.cp-summit-drawer__back-to-two');

    function openMenu() {
      menu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');

    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.classList.remove('is-level-two');

      menu.classList.remove('is-level-three');

      trigger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');

      panels.forEach(function(panel) {
        panel.classList.remove('is-active');
      });

      subPanels.forEach(function(panel) {
  panel.classList.remove('is-active');
});
    }

    function openPanel(handle) {
      panels.forEach(function(panel) {
        panel.classList.toggle(
          'is-active',
          panel.getAttribute('data-cp-panel') === handle
        );
      });

      menu.classList.add('is-level-two');
    }

    function openSubPanel(handle) {
  subPanels.forEach(function(panel) {
    panel.classList.toggle(
      'is-active',
      panel.getAttribute('data-cp-sub-panel-content') === handle
    );
  });

  menu.classList.add('is-level-three');
}

    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    departments.forEach(function(department) {
      department.addEventListener('click', function() {
        openPanel(department.getAttribute('data-cp-department'));
      });
    });

    subPanelTriggers.forEach(function(trigger) {
  trigger.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();

    openSubPanel(trigger.getAttribute('data-cp-sub-panel'));
  });
});

if (backToTwoButton) {
  backToTwoButton.addEventListener('click', function() {
    menu.classList.remove('is-level-three');
  });
}

    if (backButton) {
      backButton.addEventListener('click', function() {
        menu.classList.remove('is-level-two');
      });
    }

    closeButtons.forEach(function(button) {
      button.addEventListener('click', closeMenu);
    });

    document.addEventListener('click', function(event) {
      if (!menu.contains(event.target)) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeMenu();
      }
    });

  });

});

/* ---- was header.liquid line 1431 ---- */
(function () {
  function openMegaMenu(megaMenu) {
    var wrapper = megaMenu.querySelector('.mega-menu-main-wrapper');
    var toggle = megaMenu.querySelector('.button-mega-menu-toggle');

    megaMenu.setAttribute('aria-expanded', 'true');

    if (wrapper) {
      wrapper.setAttribute('aria-hidden', 'false');
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }

    document.body.style.overflow = 'hidden';
  }

  function closeMegaMenu(megaMenu) {
    var wrapper = megaMenu.querySelector('.mega-menu-main-wrapper');
    var toggle = megaMenu.querySelector('.button-mega-menu-toggle');

    megaMenu.setAttribute('aria-expanded', 'false');

    if (wrapper) {
      wrapper.setAttribute('aria-hidden', 'true');
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }

    document.body.style.overflow = '';
  }

  function closeAllMegaMenus() {
    document.querySelectorAll('.cp-header__desktop-shop-brand mega-menu-main').forEach(function (megaMenu) {
      closeMegaMenu(megaMenu);
    });
  }

  document.addEventListener('click', function (event) {
    if (window.innerWidth < 990) {
      return;
    }

    var toggle = event.target.closest('.cp-header__desktop-shop-brand .button-mega-menu-toggle');
    var closeButton = event.target.closest('.cp-header__desktop-shop-brand .custom-mega-menu-close');
    var wrapper = event.target.closest('.cp-header__desktop-shop-brand .mega-menu-main-wrapper');

    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      var megaMenu = toggle.closest('mega-menu-main');

      if (!megaMenu) {
        return;
      }

      var isOpen = megaMenu.getAttribute('aria-expanded') === 'true';

      closeAllMegaMenus();

      if (!isOpen) {
        openMegaMenu(megaMenu);
      }

      return;
    }

    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();

      var closeMega = closeButton.closest('mega-menu-main');

      if (closeMega) {
        closeMegaMenu(closeMega);
      }

      return;
    }

    if (wrapper) {
      event.stopPropagation();
      return;
    }

    closeAllMegaMenus();
  }, true);

  document.addEventListener('click', function (event) {
    var navItem = event.target.closest('.cp-header__desktop-shop-brand .mega-menu-main-nav-item');

    if (!navItem) {
      return;
    }

    var megaMenu = navItem.closest('mega-menu-main');
    var targetId = navItem.getAttribute('href');

    if (!megaMenu || !targetId || !targetId.startsWith('#')) {
      return;
    }

    event.preventDefault();

    megaMenu.querySelectorAll('.mega-menu-main-nav-item').forEach(function (item) {
      item.classList.remove('current');
    });

    navItem.classList.add('current');

    megaMenu.querySelectorAll('.mega-menu-main-content-tab').forEach(function (tab) {
      tab.setAttribute('aria-hidden', 'true');
    });

    var targetTab = megaMenu.querySelector(targetId);

    if (targetTab) {
      targetTab.setAttribute('aria-hidden', 'false');
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllMegaMenus();
    }
  });
})();

/* ---- was header.liquid line 1572 ---- */
(function () {
    function closeCategoryDropdowns(except) {
      document.querySelectorAll('[data-cp-category-dropdown].is-open').forEach(function (dropdown) {
        if (except && dropdown === except) return;
        dropdown.classList.remove('is-open');
        var toggle = dropdown.querySelector('[data-cp-category-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-cp-category-toggle]');

      if (toggle) {
        event.preventDefault();
        event.stopPropagation();

        var dropdown = toggle.closest('[data-cp-category-dropdown]');
        var willOpen = dropdown && !dropdown.classList.contains('is-open');

        closeCategoryDropdowns(dropdown);

        if (dropdown) {
          dropdown.classList.toggle('is-open', willOpen);
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        }
        return;
      }

      if (!event.target.closest('[data-cp-category-dropdown]')) {
        closeCategoryDropdowns();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeCategoryDropdowns();
      }
    });
  })();

/* ---- was header.liquid line 1618 ---- */
(function () {
    function cpHeaderClickGarage() {
      var selectors = [
        '#cpGarageIconTrigger #cm-garage .garage-button',
        '#cpGarageIconTrigger #cm-garage .cm_toggle-dropdown',
        '#cpGarageIconTrigger #cm-garage [data-cm-role="toggle-dropdown"]',
        '#cpGarageIconTrigger #cm-garage [data-cm-role="garage-toggle"]',
        '#cpGarageIconTrigger #cm-garage button',
        '#cpGarageIconTrigger #cm-garage a',
        '#cm-garage .garage-button',
        '#cm-garage .cm_toggle-dropdown',
        '#cm-garage button',
        '#cm-garage a'
      ];

      var button = null;

      for (var i = 0; i < selectors.length; i += 1) {
        button = document.querySelector(selectors[i]);
        if (button) break;
      }

      if (!button) return false;

      try {
        button.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
        button.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
        button.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      } catch (error) {
        try { button.click(); } catch (innerError) {}
      }

      return true;
    }

    function cpHeaderBindGarage() {
      var trigger = document.getElementById('cpGarageTriggerDesktop');
      if (!trigger || trigger.dataset.cpCompactGarageFixed === 'true') return;

      trigger.dataset.cpCompactGarageFixed = 'true';
      trigger.addEventListener('click', function (event) {
        if (event.target.closest('.cm_garageDropdown')) return;

        event.preventDefault();
        event.stopPropagation();

        var tries = 0;
        var timer = window.setInterval(function () {
          tries += 1;
          if (cpHeaderClickGarage() || tries >= 25) {
            window.clearInterval(timer);
          }
        }, 120);
      }, true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cpHeaderBindGarage);
    } else {
      cpHeaderBindGarage();
    }

    document.addEventListener('shopify:section:load', cpHeaderBindGarage);
  })();

/* ---- was header.liquid line 1688 ---- */
(function () {
    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
      } else {
        callback();
      }
    }

    function closeCategoryDropdowns(except) {
      document.querySelectorAll('[data-cp-category-dropdown].is-open').forEach(function (dropdown) {
        if (except && dropdown === except) return;
        dropdown.classList.remove('is-open');
        var button = dropdown.querySelector('[data-cp-category-toggle]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    function openGarage() {
      // CPG teardown: our picker replaces the Convermax garage dialog.
      if (window.CPGFitment && typeof window.CPGFitment.openPicker === 'function') {
        window.CPGFitment.openPicker();
        return true;
      }
      if (window.Convermax && typeof window.Convermax.openVehicleDialog === 'function') {
        window.Convermax.openVehicleDialog();
        return true;
      }

      var selectors = [
        '#cm-garage .garage-button',
        '#cm-garage .cm_toggle-dropdown',
        '#cm-garage [data-cm-role="toggle-dropdown"]',
        '#cm-garage [data-cm-role="garage-toggle"]',
        '#cm-garage button',
        '#cm-garage a'
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var target = document.querySelector(selectors[i]);
        if (target) {
          try { target.click(); } catch (error) {}
          try {
            target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          } catch (error) {}
          return true;
        }
      }

      return false;
    }

    ready(function () {
      document.addEventListener('click', function (event) {
        var categoryButton = event.target.closest('[data-cp-category-toggle]');

        if (categoryButton) {
          event.preventDefault();
          event.stopPropagation();

          var dropdown = categoryButton.closest('[data-cp-category-dropdown]');
          if (!dropdown) return;

          var shouldOpen = !dropdown.classList.contains('is-open');
          closeCategoryDropdowns(dropdown);
          dropdown.classList.toggle('is-open', shouldOpen);
          categoryButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          return;
        }

        if (!event.target.closest('[data-cp-category-dropdown]')) {
          closeCategoryDropdowns();
        }
      }, true);

      document.addEventListener('click', function (event) {
        var garageTrigger = event.target.closest('#cpGarageTriggerDesktop, #cpGarageTrigger');
        if (!garageTrigger) return;
        if (event.target.closest('.cm_garageDropdown')) return;

        event.preventDefault();
        event.stopPropagation();
        openGarage();
      }, true);
    });
  })();

/* ---- was header.liquid line 1780 ---- */
(function () {
    function cpReady(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
      } else {
        callback();
      }
    }

    function cpDispatchFullClick(target) {
      if (!target) return false;

      ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (type) {
        try {
          target.dispatchEvent(new MouseEvent(type, {
            bubbles: true,
            cancelable: true,
            view: window
          }));
        } catch (error) {}
      });

      try { target.click(); } catch (error) {}
      return true;
    }

    function cpFindRealGarageButton() {
      var selectors = [
        '#cm-garage .garage-button',
        '#cm-garage .cm_toggle-dropdown',
        '#cm-garage [data-cm-role="toggle-dropdown"]',
        '#cm-garage [data-cm-role="garage-toggle"]',
        '#cm-garage button',
        '#cm-garage a',
        '#cpGarageIconTrigger .garage-button',
        '#cpGarageIconTrigger .cm_toggle-dropdown',
        '#cpGarageIconTrigger button',
        '#cpGarageIconTrigger a',
        '#cpGarageIconTriggerMobile .garage-button',
        '#cpGarageIconTriggerMobile .cm_toggle-dropdown',
        '#cpGarageIconTriggerMobile button',
        '#cpGarageIconTriggerMobile a'
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var target = document.querySelector(selectors[i]);
        if (target) return target;
      }

      return null;
    }

    function cpOpenRealGarageWithRetry() {
      // CPG teardown: our picker replaces the Convermax garage dialog.
      if (window.CPGFitment && typeof window.CPGFitment.openPicker === 'function') {
        window.CPGFitment.openPicker();
        return;
      }
      var attempts = 0;
      var maxAttempts = 40;

      function run() {
        attempts += 1;
        var button = cpFindRealGarageButton();

        if (button) {
          cpDispatchFullClick(button);
          return;
        }

        if (attempts < maxAttempts) {
          window.setTimeout(run, 150);
        }
      }

      run();
    }

    function cpCloseCategoryDropdowns(exceptDropdown) {
      document.querySelectorAll('[data-cp-category-dropdown]').forEach(function (dropdown) {
        if (exceptDropdown && dropdown === exceptDropdown) return;

        dropdown.classList.remove('is-open', 'cp-category-open');

        var button = dropdown.querySelector('[data-cp-category-toggle]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    function cpOpenCategoryDropdown(dropdown) {
      if (!dropdown) return;

      cpCloseCategoryDropdowns(dropdown);
      dropdown.classList.add('is-open', 'cp-category-open');

      var button = dropdown.querySelector('[data-cp-category-toggle]');
      if (button) button.setAttribute('aria-expanded', 'true');
    }

    cpReady(function () {
      document.addEventListener('click', function (event) {
        var garageTrigger = event.target.closest('#cpGarageTriggerDesktop, #cpGarageTrigger');

        if (!garageTrigger) return;
        if (event.target.closest('.cm_garageDropdown')) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        cpOpenRealGarageWithRetry();
      }, true);

      document.addEventListener('click', function (event) {
        var categoryButton = event.target.closest('[data-cp-category-toggle]');

        if (categoryButton) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          var dropdown = categoryButton.closest('[data-cp-category-dropdown]');
          var shouldOpen = !dropdown.classList.contains('cp-category-open');

          if (shouldOpen) {
            cpOpenCategoryDropdown(dropdown);
          } else {
            cpCloseCategoryDropdowns();
          }

          return;
        }

        if (!event.target.closest('[data-cp-category-dropdown]')) {
          cpCloseCategoryDropdowns();
        }
      }, true);
    });

    document.addEventListener('shopify:section:load', function () {
      cpCloseCategoryDropdowns();
    });
  })();

/* ---- was header.liquid line 2297 ---- */
(function() {
    function normalizePath(pathname) {
      if (!pathname) {
        return '/';
      }

      var cleanPath = pathname.split('#')[0].split('?')[0];

      if (cleanPath.length > 1) {
        cleanPath = cleanPath.replace(/\/+$/, '');
      }

      return cleanPath || '/';
    }

    function getLinkPath(link) {
      var href = link.getAttribute('href');

      if (!href || href === '#' || href.indexOf('javascript:') === 0) {
        return null;
      }

      try {
        return normalizePath(new URL(href, window.location.origin).pathname);
      } catch (error) {
        return null;
      }
    }

    function setActiveDesktopNavLink() {
      var header = document.getElementById('header');

      if (!header) {
        return;
      }

      var links = header.querySelectorAll('.cp-header__desktop-nav-links a[href]');
      var currentPath = normalizePath(window.location.pathname);
      var bestMatch = null;
      var bestMatchLength = -1;

      links.forEach(function(link) {
        var linkPath = getLinkPath(link);

        link.classList.remove('cp-active-nav-link');

        if (!linkPath) {
          return;
        }

        if (linkPath === '/') {
          if (currentPath === '/') {
            bestMatch = link;
            bestMatchLength = 1;
          }

          return;
        }

        if (currentPath === linkPath || currentPath.indexOf(linkPath + '/') === 0) {
          if (linkPath.length > bestMatchLength) {
            bestMatch = link;
            bestMatchLength = linkPath.length;
          }
        }
      });

      if (bestMatch) {
        bestMatch.classList.add('cp-active-nav-link');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setActiveDesktopNavLink);
    } else {
      setActiveDesktopNavLink();
    }

    window.addEventListener('pageshow', setActiveDesktopNavLink);
  })();

/* ---- was header.liquid line 2381 ---- */
(function () {
    function cpTriggerNativeClick(element) {
      if (!element) return false;

      try {
        element.click();
        return true;
      } catch (error) {
        try {
          element.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          }));
          return true;
        } catch (innerError) {
          return false;
        }
      }
    }

    function cpOpenHeaderGaragePopup() {
      // CPG teardown: our picker replaces the Convermax garage dialog.
      if (window.CPGFitment && typeof window.CPGFitment.openPicker === 'function') {
        window.CPGFitment.openPicker();
        return true;
      }
      var headerGarageTrigger =
        document.getElementById('cpGarageTriggerDesktop') ||
        document.getElementById('cpGarageTrigger');

      if (headerGarageTrigger) {
        return cpTriggerNativeClick(headerGarageTrigger);
      }

      var realGarageButton = document.querySelector(
        '#cm-garage .garage-button, ' +
        '#cm-garage .cm_toggle-dropdown, ' +
        '#cm-garage [data-cm-role="toggle-dropdown"], ' +
        '#cm-garage [data-cm-role="garage-toggle"], ' +
        '#cm-garage a, ' +
        '#cm-garage button'
      );

      if (realGarageButton) {
        return cpTriggerNativeClick(realGarageButton);
      }

      if (window.Convermax && typeof window.Convermax.openVehicleDialog === 'function') {
        window.Convermax.openVehicleDialog();
        return true;
      }

      return false;
    }

    function cpNormalizeHeaderLinks() {
      var header = document.getElementById('header');
      if (!header) return;

      header.querySelectorAll('a, span').forEach(function (item) {
        var text = (item.textContent || '').replace(/\s+/g, ' ').trim();

        if (text.indexOf('+1 (210) 645-5510') !== -1 && item.tagName.toLowerCase() === 'a') {
          item.setAttribute('href', 'tel:+12106455510');
        }

        if (/^Order Status$/i.test(text) && item.tagName.toLowerCase() === 'a') {
          item.setAttribute('href', '/pages/order-status');
        }

        if (/^My Garage$/i.test(text) && item.tagName.toLowerCase() === 'a') {
          item.setAttribute('href', '#');
          item.setAttribute('data-cp-open-garage-menu', 'true');
        }
      });
    }

    document.addEventListener('DOMContentLoaded', cpNormalizeHeaderLinks);
    document.addEventListener('shopify:section:load', cpNormalizeHeaderLinks);

    document.addEventListener('click', function (event) {
      var garageLink = event.target.closest('#header [data-cp-open-garage-menu]');

      if (!garageLink) return;

      event.preventDefault();
      event.stopPropagation();

      cpOpenHeaderGaragePopup();
    }, true);
  })();

/* ---- was header.liquid line 2478 ---- */
(function () {
    function cpInitCountryCustomSelect() {
      var form = document.getElementById('CpHeaderCountryForm');
      var select = document.getElementById('CpHeaderCountrySelect');
      var custom = document.querySelector('#header [data-cp-country-custom]');

      if (!form || !select || !custom || custom.dataset.initialized === 'true') return;

      custom.dataset.initialized = 'true';

      var toggle = custom.querySelector('.cp-ref-country-button');
      var list = custom.querySelector('.cp-ref-country-list');

      if (!toggle || !list) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var isOpen = !list.hasAttribute('hidden');

        if (isOpen) {
          list.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          list.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      list.querySelectorAll('[data-country-code]').forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          var countryCode = option.getAttribute('data-country-code');

          if (!countryCode) return;

          select.value = countryCode;
          form.submit();
        });
      });

      document.addEventListener('click', function () {
        list.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('DOMContentLoaded', cpInitCountryCustomSelect);
    document.addEventListener('shopify:section:load', cpInitCountryCustomSelect);
  })();

/* ---- was header.liquid line 3926 ---- */
(function () {
    function forceClick(el) {
      if (!el) return false;
      try { el.click(); } catch (e) {}
      try {
        el.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));
      } catch (e) {}
      return true;
    }

    function getRealGarageRoot() {
      return document.querySelector('#cpGarageIconTrigger #cm-garage');
    }

    function getRealGarageButton() {
      var root = getRealGarageRoot();
      if (!root) return null;

      return root.querySelector(
        '.garage-button, .cm_toggle-dropdown, [data-cm-role="toggle-dropdown"], [data-cm-role="garage-toggle"], a, button'
      );
    }

    function openGarageWithRetry() {
  // CPG teardown: our picker replaces the Convermax garage dialog.
  if (window.CPGFitment && typeof window.CPGFitment.openPicker === 'function') {
    window.CPGFitment.openPicker();
    return;
  }
  var tries = 0;
  var maxTries = 25;

  function run() {
    tries += 1;
    var btn = getRealGarageButton();
    if (btn) {
      forceClick(btn);
      setTimeout(centerGaragePopupOnMobile, 120);
      setTimeout(centerGaragePopupOnMobile, 300);
      return;
    }
    if (tries < maxTries) {
      setTimeout(run, 180);
    }
  }

  run();
 }

    function moveGarageForMobile() {
      var desktopMount = document.querySelector('#cpGarageIconTrigger');
      var mobileAnchor = document.querySelector('#cpGarageIconTriggerMobile');
      var garage = document.getElementById('cm-garage');

      if (!desktopMount || !mobileAnchor || !garage) return;

      if (window.innerWidth <= 989) {
        if (!mobileAnchor.contains(garage)) {
          mobileAnchor.innerHTML = '';
          mobileAnchor.appendChild(garage);
        }
      } else {
        if (!desktopMount.contains(garage)) {
          desktopMount.innerHTML = '';
          desktopMount.appendChild(garage);
        }
      }
    }

    function bindGarageClicks() {
      var desktopTrigger = document.getElementById('cpGarageTriggerDesktop');
      var mobileTrigger = document.getElementById('cpGarageTrigger');

      if (desktopTrigger && !desktopTrigger.dataset.bound) {
        desktopTrigger.dataset.bound = 'true';
        desktopTrigger.addEventListener('click', function (e) {
          if (e.target.closest('.cm_garageDropdown')) return;
          e.preventDefault();
          e.stopPropagation();
          openGarageWithRetry();
        });
      }

      if (mobileTrigger && !mobileTrigger.dataset.bound) {
        mobileTrigger.dataset.bound = 'true';
        mobileTrigger.addEventListener('click', function (e) {
          if (e.target.closest('.cm_garageDropdown')) return;
          e.preventDefault();
          e.stopPropagation();
          openGarageWithRetry();
        });
      }
    }

    function centerGaragePopupOnMobile() {
  if (window.innerWidth > 989) return;

  var dropdown = document.querySelector('.cm_garageDropdown');
  if (!dropdown) return;

  dropdown.style.position = 'fixed';
  dropdown.style.left = '50%';
  dropdown.style.top = '50%';
  dropdown.style.right = 'auto';
  dropdown.style.bottom = 'auto';
  dropdown.style.transform = 'translate(-50%, -50%)';
  dropdown.style.width = 'min(92vw, 420px)';
  dropdown.style.maxWidth = '92vw';
  dropdown.style.maxHeight = '80vh';
  dropdown.style.overflowY = 'auto';
  dropdown.style.zIndex = '9999';
}

    function initGarage() {
  moveGarageForMobile();
  bindGarageClicks();
  centerGaragePopupOnMobile();
}

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGarage);
    } else {
      initGarage();
    }

    window.addEventListener('resize', moveGarageForMobile);
    document.addEventListener('shopify:section:load', initGarage);
  })();
